import { render, staticRenderFns } from "./FormValidateButtonConfig.vue?vue&type=template&id=1697f413&scoped=true"
import script from "./FormValidateButtonConfig.vue?vue&type=script&lang=js"
export * from "./FormValidateButtonConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1697f413",
  null
  
)

export default component.exports